import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { acPopVizibil } from '../actions/acPopVizibil';
import { acAxiosRequest } from '../actions/acAxiosRequest';
import { acConSizeChange } from '../actions/acConSizeChange';
class PopIstoricRunde extends React.Component {

    constructor() {
        super();
        this.state = {
            pag: 0,
            height: null
        }
    }
    componentDidMount() {
        var axios = {
            ruta: this.props.appProps.ruta,
            request: 'get_rounds',
            reducer: 'ISTORIC_RUNDE',
            value: 'lottery_name=' + this.props.activeLot.name_lot.replace(/ /g, "_") + '&type=1&next_page=0',
            extra: 'runde',
            error: '3201',
            newParam: this.props.sessionParam
        }
        this.props.acAxiosRequest(axios)
    }
    componentDidUpdate() {
        if (this.refPopRH && this.state.height === null) {
            if (this.props.conSizeChange && this.props.conSizeChange.colMid < this.refPopRH.offsetHeight) {
                this.setState({ height: this.refPopRH.offsetHeight + 120 })
                this.props.acConSizeChange({ colMid: this.refPopRH.offsetHeight + 120 })
            }
        }
    }
    popHead() {
        return (
            <div className="con-title">
                {/* <div onClick={this.closePop.bind(this)}><img alt="" src="img/icon/close-runde.png" /></div> */}
                <div className="popup-title"><span>{this.props.multiLang.rezultate.txt}</span><span onClick={this.closePop.bind(this)}>X</span></div>
                <div className="popup-title2"><span>{this.props.activeLot.name_lot}</span></div>
            </div>
        )
    }
    timeStartTrim(val) {
        var data = val.split(' ')[0];
        var ora = val.split(' ')[1];
        var dataArr = data.split('-')
        var oraArr = ora.split(':')
        var data2 = "" + dataArr[2] + "." + dataArr[1] + "";
        var ora2 = "" + oraArr[0] + ":" + oraArr[1] + "";
        return (
            <table className="child-tabel">
                <tbody>
                    <tr>
                        <td>{data2}</td>
                        <td>{ora2}</td>
                        <td className="lotteryName">{this.props.activeLot.name_lot}</td>
                    </tr>
                </tbody>
            </table>
        )
    }
    arrToTd(val) {
        if (val && this.props.conSizeChange.appW > 500) {
            var td = val.split(',').map((val, i) => {
                return (<td key={i}>{val}</td>)
            });
            return td;
        } else if (val) {
            td = val.split(',').map((val, i) => {
                return (<span key={i} className="numbert">{val}</span>)
            });
            return (<td className="numbersContainer">{td}</td>)
        } else if(this.props.activeLot && this.props.activeLot.game_type && this.props.activeLot.game_type.includes("/")) {
            let nbExtracted = this.props.activeLot.game_type.split("/")[0], columns = []
            if(nbExtracted) {
                for(let n = 0; n < parseInt(nbExtracted); n++) {
                    columns.push(<td className="numbersContainer">-</td>)
                }
                return columns
            }
        }
    }
    popBody() {
        var body = this.props.istoricRunde.response.map((val, i) => {
            return (
                <tr key={i}>
                    <td>{this.timeStartTrim(val.timeStart)}</td>
                    {this.arrToTd(val.numbers)}
                </tr>)
        });
        return body
    }
    closePop() {
        this.props.acPopVizibil({ popVizibil: false });
    }

    disabledButInc() {
        this.disabledButDec()
        if ((this.props.istoricRunde.response.length < 30) || ((this.props.istoricRunde.response.tickets) && (this.props.istoricRunde.response.tickets.length < 30))) {
            return true
        } else {
            return false
        }
    }
    disabledButDec() {
        if (this.state.pag === 0) {
            return true
        } else {
            return false
        }
    }
    sendFiltre(val) {
        var axios = {
            ruta: this.props.appProps.ruta,
            request: 'get_rounds',
            reducer: 'ISTORIC_RUNDE',
            value: 'lottery_name=' + this.props.activeLot.name_lot.replace(/ /g, "_") + '&type=1&next_page=' + val + '',
            extra: 'runde',
            error: '3210',
            newParam: this.props.sessionParam
        }
        this.props.acAxiosRequest(axios);
    }
    pagChange(val) {
        var pagInc = 0
        if (val === 'inc') {
            pagInc = this.state.pag + 1
        }
        else if (val === 'dec') {
            pagInc = this.state.pag - 1
        }
        if (pagInc < 0) {
            pagInc = 0;
        }
        this.setState({ pag: pagInc });
        this.sendFiltre(pagInc);
    }
    render() {
        if (this.props.istoricRunde) {
            return (
                <div ref={(f) => this.refPopRH = f} className="popUp-Content runde">

                    <div className="runde-child">
                        {this.popHead()}
                        {/* <div className="titlePopLottery">{this.props.activeLot.name_lot}</div> */}
                        <table>
                            <tbody>
                                {this.popBody()}
                            </tbody>
                        </table>
                        <div className="pagination">
                            <button onClick={this.pagChange.bind(this, 'dec')} disabled={this.disabledButDec()}></button>
                            <button onClick={this.pagChange.bind(this, 'inc')} disabled={this.disabledButInc()}></button>
                        </div>
                    </div>
                </div>
            )
        } else {
            return <div></div>
        }
    }
}
function mapStateToProps(state) {
    return {
        popVizibil: state.popVizibil,
        multiLang: state.multiLang,
        activeLot: state.activeLot,
        istoricRunde: state.istoricRunde,
        appProps: state.appProps,
        conSizeChange: state.conSizeChange,
        sessionParam: state.sessionParam
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        acPopVizibil: acPopVizibil,
        acAxiosRequest: acAxiosRequest,
        acConSizeChange: acConSizeChange
    }, dispatch)
}
export default connect(mapStateToProps, matchDispatchToProps)(PopIstoricRunde);